import image from "../assets/arena_online_logo.png";
import imageLoad from "../assets/arena_online_logo.png";
import imageReprint from "../assets/ao_logo_print.png";
import loadingGif from "../assets/loading.gif";
import imageLogoTicket from "../assets/titan_logo_print.png";
import imageLogin from "../assets/titan_logo.png";

class ThemeModel {
  constructor (data = {}) {
    this.site_name = data.site_name || 'ARENA ONLINE';
    this.site_name_header = data.site_name_header || 'Arena Online';
    this.logo_site = data.logo_site || image;
    this.logo_site_load = data.logo_site_load || imageLoad;
    this.logo_reprint = data.logo_reprint || imageReprint;
    this.loading_gif = data.loading_gif || loadingGif;
    this.logo_ticket = data.logo_ticket || imageLogoTicket;
    this.logo_login = data.logo_login || imageLogin;
  }
}

export default ThemeModel;